"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentResponseRequiredToJSON = exports.AttachmentResponseRequiredFromJSONTyped = exports.AttachmentResponseRequiredFromJSON = void 0;
const runtime_1 = require("../runtime");
function AttachmentResponseRequiredFromJSON(json) {
    return AttachmentResponseRequiredFromJSONTyped(json, false);
}
exports.AttachmentResponseRequiredFromJSON = AttachmentResponseRequiredFromJSON;
function AttachmentResponseRequiredFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'backside': !runtime_1.exists(json, 'backside') ? undefined : json['backside'],
        'fields': !runtime_1.exists(json, 'fields') ? undefined : json['fields'],
    };
}
exports.AttachmentResponseRequiredFromJSONTyped = AttachmentResponseRequiredFromJSONTyped;
function AttachmentResponseRequiredToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'backside': value.backside,
        'fields': value.fields,
    };
}
exports.AttachmentResponseRequiredToJSON = AttachmentResponseRequiredToJSON;
//# sourceMappingURL=AttachmentResponseRequired.js.map